/* eslint-disable */
/**
 * Agregaciones base y compatibilidad con las métricas de V1.
 *
 * Los métodos operan sobre la instancia de PanelLogic y no mantienen estado global.
 */
const logic = {
  evo(st, tol, gap, stripes, pct) {
    const D = this.data,
      N = D.days.length;
    const EM = {
      alarms: {
        label: 'Alarmas',
        get: c => c.al,
        sum: true,
        fmt: v => String(Math.round(v * 10) / 10),
        color: 'oklch(0.66 0.19 25)'
      },
      apv: {
        label: 'Alarmas por visita',
        get: c => c.apv,
        sum: true,
        fmt: v => v.toFixed(2),
        color: 'oklch(0.66 0.19 25)'
      },
      sfr: {
        label: 'SFR corregido',
        get: c => c.sfr,
        fmt: v => v.toFixed(0) + ' %'
      },
      ppa: {
        label: 'Pellets perdidos',
        get: c => c.ppa,
        sum: true,
        fmt: v => String(Math.round(v * 10) / 10),
        color: 'oklch(0.8 0.13 85)'
      },
      visitas: {
        label: 'Visitas',
        get: c => c.vis,
        sum: true,
        fmt: v => String(Math.round(v * 10) / 10),
        color: 'oklch(0.76 0.09 250)'
      }
    };
    const k = st.evoMetric,
      em = EM[k],
      isSfr = k === 'sfr',
      week = st.evoGroup === 'semana';
    const buckets = this.periodBuckets(week);
    const optBtn = (key, label, cur, field) => ({
      label,
      bg: cur === key ? 'rgba(46,179,238,0.16)' : 'transparent',
      color: cur === key ? '#e4e9f0' : '#8793a6',
      onClick: () => this.setState({
        [field]: key
      })
    });
    const opts = {
      evoOpts: [['compacta', 'Compacta'], ['todas', 'Grilla'], ['alarms', 'Alarmas'], ['apv', 'Alarmas / visita'], ['ppa', 'PPA'], ['visitas', 'Visitas'], ['sfr', 'SFR']].map(([key, label]) => optBtn(key, label, k, 'evoMetric')),
      groupOpts: [['dia', 'Por día'], ['semana', 'Por semana']].map(([key, label]) => optBtn(key, label, st.evoGroup, 'evoGroup')),
      axisOpts: [['fecha', 'Fechas'], ['jaula', 'Jaulas']].map(([key, label]) => optBtn(key, label, st.evoAxis || 'fecha', 'evoAxis')),
      nCols: buckets.length,
      isAll: k === 'todas',
      notAll: k !== 'todas' && k !== 'compacta',
      isCompact: k === 'compacta',
      showCageLegend: k !== 'compacta',
      cageLegend: D.rows.map((r, ci) => {
        const on = k !== 'compacta' ? st.gFocus === ci : ci === (st.hover ? st.hover.ci : st.sel);
        return {
          name: r.name,
          color: this.cageColor(ci),
          txt: on ? '#e4e9f0' : '#8793a6',
          fw: on ? 600 : 400,
          ol: on ? "0.092593vh solid #e4e9f0" : 'none',
          onClick: () => this.setState(s => ({
            sel: ci,
            gFocus: s.gFocus === ci ? null : ci
          }))
        };
      })
    };
    if (k === 'compacta') return {
      ...opts,
      ...this.evoCompact(st, buckets, week, EM)
    };
    if (k !== 'compacta') return {
      ...opts,
      isAll: true,
      notAll: false,
      ...this.evoAll(st, tol, pct, stripes, buckets, week, EM, k === 'todas' ? null : [k])
    };
    const agg = cs => this.v1MetricAggregate(k, cs);
    const grid = D.rows.map(r => buckets.map(b => agg(b.map(d => r.cells[d]))));
    const flat = grid.flat().filter(v => v != null);
    const vMax = isSfr ? 150 : Math.max(...flat, 0.001),
      avg = flat.reduce((a, b) => a + b, 0) / flat.length;
    const hDay = st.hover ? st.hover.di : st.day,
      hb = buckets.findIndex(b => b.includes(hDay)),
      sb = buckets.findIndex(b => b.includes(st.day));
    const sfrCol = v => Math.abs(v - 100) <= tol ? '#8793a6' : v < 100 ? 'oklch(0.7 0.14 250)' : 'oklch(0.72 0.15 55)';
    const Y = v => (isSfr ? 100 - Math.min(150, v) / 150 * 100 : 100 - v / vMax * 100).toFixed(2);
    const good = 'oklch(0.78 0.13 160)',
      badC = 'oklch(0.72 0.17 25)';
    const mean = a => {
      const l = a.filter(v => v != null);
      return l.length ? l.reduce((x, y) => x + y, 0) / l.length : null;
    };
    const evoRows = D.rows.map((r, ci) => {
      const vals = r.cells.map(c => c.ay ? null : em.get(c));
      let ma = '';
      if (!week) vals.forEach((_, i) => {
        const m = mean(vals.slice(Math.max(0, i - 6), i + 1));
        if (i >= 3 && m != null) ma += (ma ? 'L' : 'M') + (i + 0.5).toFixed(1) + ' ' + Y(m) + ' ';
      });
      const lastW = mean(vals.slice(-7)),
        prevW = mean(vals.slice(-14, -7));
      let trend = '',
        trendColor = '#5a667a';
      if (lastW != null && prevW != null) {
        if (isSfr) {
          const dv = lastW - prevW;
          trend = (dv >= 0 ? '↑ ' : '↓ ') + Math.abs(dv).toFixed(1) + ' pts 7d';
          trendColor = Math.abs(lastW - 100) < Math.abs(prevW - 100) ? good : badC;
        } else if (prevW > 0) {
          const ch = (lastW - prevW) / prevW * 100;
          trend = (ch >= 0 ? '↑ ' : '↓ ') + Math.abs(ch).toFixed(0) + ' % 7d';
          trendColor = Math.abs(ch) < 5 ? '#8793a6' : ch > 0 ? badC : good;
        }
      }
      const tot = agg(r.cells);
      return {
        name: r.name,
        bg: ci === st.sel ? 'rgba(46,179,238,0.08)' : 'transparent',
        nameColor: ci === st.sel ? '#e4e9f0' : '#b8c1ce',
        nameWeight: ci === st.sel ? 600 : 400,
        total: (em.sum ? 'total ' : 'prom. ') + em.fmt(tot),
        trend,
        trendColor,
        ma: ma || 'M0 0',
        onName: () => this.setState({
          sel: ci
        }),
        cells: buckets.map((b, bi) => {
          const v = grid[ci][bi];
          let bottom = '0%',
            h = '0%',
            bg = em.color;
          if (v == null) {
            h = '100%';
            bg = stripes;
          } else if (isSfr) {
            h = pct(Math.min(v, 150), 150);
            bg = sfrCol(v);
          } else h = pct(v, vMax);
          return {
            bottom,
            h,
            bg,
            colBg: bi === hb ? 'rgba(46,179,238,0.16)' : 'transparent',
            ol: ci === st.sel && bi === sb ? "0.092593vh solid #e4e9f0" : 'none',
            enter: () => {
              const x = this.state.hover;
              if (!x || x.di !== b[0]) this.setState({
                hover: {
                  ci,
                  di: b[0]
                }
              });
            },
            click: () => this.setState({
              sel: ci,
              day: b[0]
            })
          };
        })
      };
    });
    const tr = st.evoAxis === 'jaula',
      hCi = st.hover ? st.hover.ci : st.sel;
    const barOf = v => {
      let bottom = '0%',
        h = '0%',
        bg = em.color;
      if (v == null) {
        h = '100%';
        bg = stripes;
      } else if (isSfr) {
        h = pct(Math.min(v, 150), 150);
        bg = sfrCol(v);
      } else h = pct(v, vMax);
      return {
        bottom,
        h,
        bg
      };
    };
    const evoRowsT = !tr ? null : buckets.map((b, bi) => {
      const col = D.rows.map((_, ci) => grid[ci][bi]),
        m = mean(col);
      return {
        name: D.days[b[0]],
        bg: bi === sb ? 'rgba(46,179,238,0.08)' : 'transparent',
        nameColor: bi === sb ? '#e4e9f0' : '#b8c1ce',
        nameWeight: bi === sb ? 600 : 400,
        total: '',
        trend: '',
        trendColor: '#5a667a',
        ma: 'M0 0',
        onName: () => this.setState({
          day: b[0]
        }),
        cells: D.rows.map((r, ci) => ({
          ...barOf(grid[ci][bi]),
          ...(grid[ci][bi] == null ? {} : {
            bg: this.cageColor(ci)
          }),
          colBg: ci === hCi ? 'rgba(46,179,238,0.16)' : 'transparent',
          ol: ci === st.sel && bi === sb ? "0.092593vh solid #e4e9f0" : 'none',
          enter: () => {
            const x = this.state.hover;
            if (!x || x.ci !== ci || x.di !== b[0]) this.setState({
              hover: {
                ci,
                di: b[0]
              }
            });
          },
          click: () => this.setState({
            sel: ci,
            day: b[0]
          })
        }))
      };
    });
    const evoWeeks = week ? buckets.map(b => ({
      lab: D.days[b[0]],
      span: 1
    })) : buckets.filter((_, i) => i % 7 === 0).map((b, i) => ({
      lab: N - i * 7 < 4 ? '' : D.days[b[0]],
      span: Math.min(7, N - i * 7)
    }));
    const cur = D.rows.map((r, ci) => ({
      ci,
      name: r.name,
      v: grid[ci][hb],
      p: hb > 0 ? grid[ci][hb - 1] : null
    }));
    const live = cur.filter(o => o.v != null),
      dAvg = live.reduce((a, o) => a + o.v, 0) / Math.max(1, live.length);
    const roMax = isSfr ? 150 : Math.max(...live.map(o => o.v), 0.001);
    const roRows = [...cur].sort((a, b) => (b.v ?? -1) - (a.v ?? -1)).map(o => {
      let delta = '',
        dColor = '#5a667a';
      if (o.v != null && o.p != null) {
        const d = o.v - o.p;
        delta = (d > 0 ? '+' : d < 0 ? '−' : '±') + em.fmt(Math.abs(d)).replace(' %', '');
        dColor = Math.abs(d) < 1e-9 ? '#5a667a' : isSfr ? Math.abs(o.v - 100) < Math.abs(o.p - 100) ? good : badC : d > 0 ? badC : good;
      }
      return {
        name: o.name,
        nameColor: o.ci === st.sel ? '#e4e9f0' : '#b8c1ce',
        nameWeight: o.ci === st.sel ? 600 : 400,
        val: o.v == null ? 'ayuno' : em.fmt(o.v),
        w: o.v == null ? '0%' : pct(Math.min(o.v, roMax), roMax),
        color: isSfr ? sfrCol(o.v ?? 100) : em.color,
        delta,
        dColor
      };
    });
    const b = buckets[hb];
    return {
      ...opts,
      evoWeeks: tr ? D.rows.map((r, ci) => ({
        lab: r.name.replace(' A', ''),
        span: 1,
        c: this.cageColor(ci)
      })) : evoWeeks,
      nCols: tr ? D.rows.length : buckets.length,
      maBox: '0 0 ' + buckets.length + ' 100',
      showMa: !week && !tr,
      evoRows: tr ? evoRowsT : evoRows,
      rowH: tr ? 26 : 54,
      isSfr,
      refBottom: isSfr ? '66.67%' : '-100%',
      refLabel: isSfr ? 'Referencia 100 %' : '',
      yMaxLabel: isSfr ? '150 %' : em.fmt(vMax),
      yMinLabel: isSfr ? '0 %' : '0',
      roDay: week ? 'Semana ' + D.days[b[0]] + ' – ' + D.days[b[b.length - 1]] : D.days[b[0]],
      roMetric: em.label + ' · Δ vs ' + (week ? 'semana' : 'día') + ' anterior',
      roRows,
      roAvg: em.fmt(dAvg),
      roHint: ''
    };
  },
  cageColor(ci) {
    const L = [0.72, 0.62, 0.82][ci % 3];
    return 'oklch(' + L + ' 0.14 ' + (ci * 24 + 20) % 360 + ')';
  },
  v1MetricAggregate(metric, cells) {
    // V1 sums every backend daily metric, including both precomputed alarm
    // ratios. SFR is the only exception: it averages valid fed-day values.
    const field = {
      alarms: 'al',
      visitas: 'vis',
      ppa: 'ppa',
      apv: 'apv',
      apt: 'apt',
      kg: 'kg',
      sfr: 'sfr'
    }[metric];
    if (!field) return null;
    const values = (cells || []).filter(c => c && !c.missing && (metric !== 'sfr' || !c.ay)).map(c => c[field]).filter(Number.isFinite);
    if (!values.length) return metric === 'sfr' ? null : 0;
    const total = values.reduce((sum, value) => sum + value, 0);
    return metric === 'sfr' ? total / values.length : total;
  },
  v1AlarmsPerVisit(cells) {
    return this.v1MetricAggregate('apv', cells);
  }
};
export default logic;
